import React from 'react'
import { CompanyHeadings, CompanyImg, CompanyLinksBackgroundImg, CompanyOrderdList, CompanyParagraphTexts } from './CompanyLinksStyled';
import Container from 'components/layout/Container';
import Header from 'components/Header';

const Blogs: React.FC = () => {

    return (
        <>
            <Header />

            <CompanyLinksBackgroundImg>
                <Container>
                    <CompanyHeadings>
                        Introduction
                    </CompanyHeadings>

                    <CompanyParagraphTexts>
                        Win Crypto Cash: Bitcoin Earning is a real time paying game in which you just match different coins to earn real crypto and transfer it direct to your wallet in Coin base, kraken, Binance and other Exchanges where your wallet exists.
                        You can convert the bitcoin into USD currency in your exchange after sending them into your wallet instantly.
                    </CompanyParagraphTexts>

                    <CompanyParagraphTexts>
                        Have fun matching Coins of same kinds at least three of them horizontally or vertically. There will also be big bomb blast tiles too if you strike them you get a big number of score with just a hit that one tile.
                    </CompanyParagraphTexts>
                    <CompanyParagraphTexts>
                        You will earn real crypto to get rich and feel good and satisfied.
                    </CompanyParagraphTexts>
                    <CompanyParagraphTexts>
                        So basically in Win Crypto Cash: Bitcoin Earning you get money to earn. The more you play the more you earn real money that is in the form of crypto.
                    </CompanyParagraphTexts>

                    <CompanyOrderdList>
                        <ol>
                            <li>Fun to play</li>
                            <li> Real time crypto earning</li>
                            <li>Free to play</li>
                            <li>Instant withdrawals</li>
                            <li>Chances to bring your life some ease by quitting your job and having fun</li>
                            <li>Future investments can be saved and can be turned into millions.</li>
                        </ol>
                    </CompanyOrderdList>

                    <CompanyParagraphTexts>
                        So what are you waiting for download now Win Crypto Cash: Bitcoin Earning and start earning real crypto to change it into cash and change your life.
                    </CompanyParagraphTexts>

                    <CompanyImg>
                        <img src='./assets/blogs/blogs.png' alt='' />
                    </CompanyImg>

                </Container>
            </CompanyLinksBackgroundImg>
        </>
    )
}

export default Blogs;